import { MutationTree, ActionTree, GetterTree } from 'vuex'
import { getRedemptionNotification } from '@/utils/redemption'
import { SET_NOTIFICATION } from '@/store/types'
import { RootState } from '..'

export interface NotificationState {
  ticket: object | null;
}

const state: NotificationState = {
  ticket: {},
}

const getters: GetterTree<NotificationState, RootState> = {
  ticketOrder: (state) => state.ticket,
}

const mutations: MutationTree<NotificationState> = {
  [SET_NOTIFICATION](state, ticket) {
    state.ticket = ticket
  },
}

const actions: ActionTree<NotificationState, RootState> = {
  async loadNotification({ commit }) {
    const notification = await getRedemptionNotification()
    return commit(SET_NOTIFICATION, notification)
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
